<template>
  <v-container>
    <v-layout class="mb-3" justify-center>
      <v-flex xs12 md8>
        <v-img :src="images.homeIMG"></v-img>
      </v-flex>
    </v-layout>
    <br />
    <v-layout col wrap text-xs-center class="mb-5">
      <v-flex xs12>
        <!-- <h1 class="display-3">Welcome to Aegeo Spas Phone Book</h1> -->
        <v-card flat class="transparent">
          <span>
            <h1 style="color:#0b2b49">Welcome to Aegeo Spas Phone Book</h1>
          </span>
        </v-card>
      </v-flex>
      <!-- <v-speed-dial>
        <template v-slot:activator >
          <v-btn v-model="fab" color="blue darken-2" dark fab  bottom right  >
            <v-icon v-if="fab">close</v-icon>
            <v-icon v-else>add</v-icon>
          </v-btn>
        </template>

        <v-btn fab dark  small color="green" router to="/ContactList/new">
          <v-icon>person_add</v-icon>
        </v-btn>
        <v-btn fab small color="lime" router to="/HotelList/new">
          <v-icon>hotel</v-icon>
        </v-btn>
      </v-speed-dial>-->
    </v-layout>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      images: {
        homeIMG: require("@/assets/AEGEO_SPAS-intro.jpg")
      }
    };
  },

  // data() {
  //   return {

  //   };
  // },
  computed: {
    userisAuthenticated() {
      return (
        this.$store.getters.user !== null &&
        this.$store.getters.user !== undefined
      );
    }
  }
};
</script>




